























































import Vue, { PropType } from "vue";
import NameComp from "../menu/NameComp.vue";
import _raids from "@/services/endpoints/raids";
import { userRaid } from "models/Types";
import { Spieler } from "models/Spieler";

export default Vue.extend({
	name: "LieutenantComp",
	components: { NameComp },
	props: {
		raid: Object as PropType<userRaid>,
		disabled: Boolean
	},
	data: () => ({
		lieutenants: [] as number[],
		players: [] as Spieler[],
		searchInput: '',
	}),
	computed: {
		isDisabled: function(): boolean {
			return this.disabled || this.lieutenants.length >= 2;
		}
	},
	methods: {
		customFilter: function(item: Spieler, queryText: string): boolean {
			const name = item.name.toLowerCase();
			const accname = item.accname.toLowerCase();
			const searchText = queryText.toLowerCase();

			return name.indexOf(searchText) > -1 || accname.indexOf(searchText) > -1;
		},
		getLieutenants: function(): Spieler[] {
			return this.players.filter(p => this.lieutenants.includes(p.id));
		},
		removeLieutenant: function(lieutenant: Spieler): void {
			this.lieutenants = this.lieutenants.filter(l => l != lieutenant.id);
		}
	},
	watch: {
		lieutenants: async function(newValue: number[], oldValue: number[]): Promise<void> {
			this.searchInput = '';
			if (oldValue === null) return;
			const invitedPlayer = newValue.find(player => !oldValue.includes(player));
			const deletedPlayer = oldValue.find(player => !newValue.includes(player));
			if (invitedPlayer) {
				await _raids.setLieutenantRole(this.raid.id, invitedPlayer, 1);
			} else if (deletedPlayer) {
				await _raids.setLieutenantRole(this.raid.id, deletedPlayer, 0);
			}
		}
	},
	created: async function(): Promise<void> {
		if (this.raid) {
			this.players = await _raids.listPlayers(this.raid.id);
			this.players = this.players.filter(s => s.role < 2);
			this.lieutenants = this.players.filter(s => s.role === 1).map(s => s.id);
		}
	}
});
